import api from "@/router/api";

export default {
  /**
   * Busca imagens de uma ação específica com suporte a paginação
   * GET /acao-imagem/{acaoId}
   */
  async getAcaoImagensByAcaoId(acaoId, page = 0, size = 10) {
    const response = await api.get(`/acao-imagem/${acaoId}`, {
      params: { page, size },
    });
    return response.data;
  },

  /**
   * Adiciona uma nova imagem a uma ação
   * POST /acao-imagem/{acaoId}
   */
  async postAcaoImagem(acaoId, imagemData) {
    const response = await api.post(`/acao-imagem/${acaoId}`, imagemData);
    return response.data;
  },

  /**
   * Adiciona múltiplas imagens a uma ação em lote
   * POST /acao-imagem/{acaoId}/lote
   */
  async postLoteAcaoImagem(acaoId, imagensData) {
    const response = await api.post(`/acao-imagem/${acaoId}/lote`, imagensData);
    return response.data;
  },

  /**
   * Deleta uma imagem da ação pelo ID
   * DELETE /acao-imagem/imagem/{acaoImagemId}
   */
  async deleteAcaoImagem(acaoImagemId) {
    const response = await api.delete(`/acao-imagem/imagem/${acaoImagemId}`);
    return response.data;
  },
};
